import { useState } from "react";
import T from "../../theme";
import { Btn } from "./Btn";

const LS_KEY = "vg-cookie-consent";

/** Returns true if the user has already responded to the cookie banner. */
export function hasCookieConsent() {
  return localStorage.getItem(LS_KEY) !== null;
}

export const CookieBanner = () => {
  const [visible, setVisible] = useState(!hasCookieConsent());
  const [showDetails, setShowDetails] = useState(false);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem(LS_KEY, "accepted");
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(LS_KEY, "rejected");
    setVisible(false);
  };

  return (
    <div style={{
      position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 10000,
      background: T.card, borderTop: `1px solid ${T.border}`,
      boxShadow: "0 -4px 24px rgba(0,0,0,0.15)",
      padding: "20px 24px",
      animation: "fadeIn 0.3s ease",
    }}>
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: 14, flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 280 }}>
            <p style={{ fontSize: 14, fontWeight: 600, color: T.text, marginBottom: 6 }}>
              🍪 Utilização de cookies e armazenamento local
            </p>
            <p style={{ fontSize: 13, color: T.textMuted, lineHeight: 1.6, marginBottom: showDetails ? 12 : 0 }}>
              O VillaGest utiliza armazenamento local (localStorage) para o funcionamento essencial da plataforma.
              Não utilizamos cookies de terceiros, analytics ou rastreamento.
            </p>

            {showDetails && (
              <div style={{
                background: T.bg, border: `1px solid ${T.border}`, borderRadius: T.radius,
                padding: 14, marginBottom: 8,
              }}>
                <p style={{ fontSize: 12, fontWeight: 600, color: T.text, marginBottom: 10 }}>
                  Dados armazenados no seu navegador:
                </p>

                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
                      <span style={{ fontSize: 12, fontWeight: 600, color: T.text }}>Sessão de autenticação</span>
                      <span style={{
                        fontSize: 10, padding: "1px 6px", borderRadius: 4,
                        background: T.primaryLight, color: T.primary, fontWeight: 600,
                      }}>Essencial</span>
                    </div>
                    <p style={{ fontSize: 11, color: T.textMuted, lineHeight: 1.5 }}>
                      Tokens de sessão geridos pelo Supabase para manter o login ativo. Removidos ao fazer logout.
                    </p>
                  </div>

                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
                      <span style={{ fontSize: 12, fontWeight: 600, color: T.text }}>Preferência de tema</span>
                      <span style={{
                        fontSize: 10, padding: "1px 6px", borderRadius: 4,
                        background: T.primaryLight, color: T.primary, fontWeight: 600,
                      }}>Funcional</span>
                    </div>
                    <p style={{ fontSize: 11, color: T.textMuted, lineHeight: 1.5 }}>
                      Guarda a sua preferência de modo claro/escuro (<code style={{ fontSize: 10, background: T.bg, padding: "1px 4px", borderRadius: 3 }}>vg-dark</code>).
                    </p>
                  </div>

                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
                      <span style={{ fontSize: 12, fontWeight: 600, color: T.text }}>Condomínio ativo</span>
                      <span style={{
                        fontSize: 10, padding: "1px 6px", borderRadius: 4,
                        background: T.primaryLight, color: T.primary, fontWeight: 600,
                      }}>Funcional</span>
                    </div>
                    <p style={{ fontSize: 11, color: T.textMuted, lineHeight: 1.5 }}>
                      Memoriza o condomínio selecionado para não ter de escolher a cada login (<code style={{ fontSize: 10, background: T.bg, padding: "1px 4px", borderRadius: 3 }}>vg-active-condo</code>).
                    </p>
                  </div>

                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
                      <span style={{ fontSize: 12, fontWeight: 600, color: T.text }}>Consentimento de cookies</span>
                      <span style={{
                        fontSize: 10, padding: "1px 6px", borderRadius: 4,
                        background: T.primaryLight, color: T.primary, fontWeight: 600,
                      }}>Essencial</span>
                    </div>
                    <p style={{ fontSize: 11, color: T.textMuted, lineHeight: 1.5 }}>
                      Regista a sua resposta a este aviso (<code style={{ fontSize: 10, background: T.bg, padding: "1px 4px", borderRadius: 3 }}>vg-cookie-consent</code>).
                    </p>
                  </div>

                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
                      <span style={{ fontSize: 12, fontWeight: 600, color: T.text }}>Notificações lidas</span>
                      <span style={{
                        fontSize: 10, padding: "1px 6px", borderRadius: 4,
                        background: T.primaryLight, color: T.primary, fontWeight: 600,
                      }}>Funcional</span>
                    </div>
                    <p style={{ fontSize: 11, color: T.textMuted, lineHeight: 1.5 }}>
                      Regista quais notificações do condomínio já foram visualizadas (<code style={{ fontSize: 10, background: T.bg, padding: "1px 4px", borderRadius: 3 }}>vg-dismissed-notifs</code>).
                    </p>
                  </div>
                </div>
              </div>
            )}

            <button
              onClick={() => setShowDetails(d => !d)}
              style={{
                background: "none", border: "none", cursor: "pointer", padding: 0,
                fontSize: 12, color: T.primary, fontWeight: 500, marginTop: 6,
              }}
            >
              {showDetails ? "Ocultar detalhes ▲" : "Ver detalhes ▼"}
            </button>
          </div>

          <div style={{ display: "flex", gap: 8, alignItems: "center", flexShrink: 0, alignSelf: "center" }}>
            <Btn variant="secondary" onClick={reject} style={{ fontSize: 13, padding: "8px 16px" }}>
              Rejeitar
            </Btn>
            <Btn onClick={accept} style={{ fontSize: 13, padding: "8px 16px" }}>
              Aceitar
            </Btn>
          </div>
        </div>
      </div>
    </div>
  );
};
